module.exports = __webpack_public_path__ + "static/media/Plootus 401k Guide.0c8963ae.pdf";